module.exports = __webpack_public_path__ + "img/pic_311570.35111dfd.jpg";